import { MultiPrintArbre } from '@repo/print-pdf/arbre/print';
import { PRINT_TEMPLATES_ENABLED, useEffectiveArbreTemplate } from '../../../../features/print-templates/template-source';

export default function MultiPrintArbrePage() {
  // Modèle de fiche de l'organisation ; on attend sa réponse pour ne pas imprimer la fiche par défaut par erreur.
  const { template, isLoading } = useEffectiveArbreTemplate();
  if (isLoading) return <div className="w-full py-6">Chargement du modèle de fiche...</div>;

  return (
    <div className="w-full py-6">
      <MultiPrintArbre template={PRINT_TEMPLATES_ENABLED ? template : undefined} />
    </div>
  );
}
